import { verticals } from "@resourcehub/resourcehub-assets";

export default ({ strings }) => [
    {
        image: {
            alt: strings.verticals_education_primary,
            asset_static: verticals.educationPrimaryCirclePng
        },
        link: {
            destination: "/schools"
        },
        name: strings.verticals_education_primary,
        title: {
            content: strings.verticals_education_primary,
            type: "card-title"
        }
    }
];
